/** Autenticação, tenancy e convites (docs/02 §3). */
import { z } from "zod";
import { inviteStatus, membershipRole } from "../enums.js";
import { uuid } from "./common.js";

/* ---------- Auth / tenancy ---------- */
export const loginInput = z.object({
  email: z.string().email(),
  password: z.string().min(1),
});
export type LoginInput = z.infer<typeof loginInput>;

export const tenantSummary = z.object({
  id: uuid,
  name: z.string(),
  slug: z.string(),
  role: membershipRole,
  channels: z.number().int().nonnegative(),
  unread: z.number().int().nonnegative(),
});
export type TenantSummary = z.infer<typeof tenantSummary>;

export const meOutput = z.object({
  id: uuid,
  name: z.string(),
  email: z.string().email(),
  locale: z.string(),
  isSuperadmin: z.boolean(),
  tenants: z.array(tenantSummary),
});
export type MeOutput = z.infer<typeof meOutput>;

export const loginOutput = z.object({
  accessToken: z.string(),
  me: meOutput,
});
export type LoginOutput = z.infer<typeof loginOutput>;

export const acceptInviteInput = z.object({
  token: z.string().min(10),
  password: z.string().min(10),
  name: z.string().min(1),
});

export const inviteMemberInput = z.object({
  email: z.string().email(),
  role: membershipRole,
});

/* ---------- Convite (info pública) ---------- */
export const inviteInfo = z.object({
  tenantName: z.string(),
  role: membershipRole,
  email: z.string(),
  status: inviteStatus,
});
export type InviteInfo = z.infer<typeof inviteInfo>;
